module.exports = __webpack_public_path__ + "assets/images/premium-features/timeoff-banner-new-084bfb.png";